import { Dialog } from '@elementary/common-ui/components';
import { GPGKey } from '../types';
import useGPGKeys from '../hooks/useGPGKeys';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  gpgKey: GPGKey;
}

const RevokeKeyDialog = ({ isOpen, onClose, gpgKey }: Props) => {
  const { revokeKey, isRevoking } = useGPGKeys();

  const handleRevoke = () => {
    revokeKey(gpgKey.keyId, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title="Revoke GPG Key"
      confirmText="Revoke Key"
      variant="error"
      isLoading={isRevoking}
      message={`Are you sure you want to revoke the GPG key "${gpgKey.keyId}"?`}
      secondaryMessage="Revoking this key will prevent it from being used for signing commits. This action cannot be undone."
      onConfirmButtonClick={handleRevoke}
    />
  );
};

export default RevokeKeyDialog;
